import { render } from "./HelpDialogProject.vue?vue&type=template&id=4b0fe8e4"
import script from "./HelpDialogProject.vue?vue&type=script&lang=js"
export * from "./HelpDialogProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__